import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=1edd427a"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports